import { combineReducers } from "@reduxjs/toolkit";
import menuProductDetailSlice from "./slices/menuProductDetailSlice";
import menuProductSlice from "./slices/menuProductSlice";
import terminalSlice from "./slices/terminalSlice";
import documentPrintCopySlice from "./slices/documentPrintCopySlice";
import printerSlice from "./slices/printerSlice";

export default combineReducers({
  terminal: terminalSlice,
  documentPrintCopy: documentPrintCopySlice,
  menuProduct: menuProductSlice,
  menuProductDetail: menuProductDetailSlice,
  posPrinter: printerSlice,
});
